import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import { LocalizationContext } from '../App';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { ThemeProvider, useTheme, createTheme } from '@mui/material/styles';
import { pink } from '@mui/material/colors';

import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RoomIcon from '@mui/icons-material/Room';

const LoupeAppBar = props => {

    const navigate = useNavigate();    
    const fg = pink.A700;

    return(

        <LocalizationContext.Consumer>

            { ({strings}) =>   

                <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" className="topMenu">                         
                    <Button onClick={() => navigate('/', { replace : true })}>
                        <>
                            {strings.getString("controls.buttons.menu.start")}
                        </>
                    </Button>
                    <Button onClick={() => navigate('/about', { replace : true })}>
                        <>
                            {strings.getString("controls.buttons.menu.about")}
                        </>
                    </Button>        
                    <Button onClick={() => navigate('/activities-here', { replace : true })}>
                        <>
                            {strings.getString("controls.buttons.activity.local")}                            
                        </>
                    </Button>
                </Stack>  

            }

        </LocalizationContext.Consumer>

    );

}
export default LoupeAppBar;